import React, { SVGProps } from "react";

export default function SupGridSmall(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5V3H5ZM6 4H5C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6C5.55228 6 6 5.55228 6 5V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3C8.89543 3 8 3.89543 8 5C8 6.10457 8.89543 7 10 7C11.1046 7 12 6.10457 12 5V3H10ZM11 4H10C9.44772 4 9 4.44772 9 5C9 5.55228 9.44772 6 10 6C10.5523 6 11 5.55228 11 5V4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5C13 3.89543 13.8954 3 15 3H17V5C17 6.10457 16.1046 7 15 7C13.8954 7 13 6.10457 13 5ZM15 4H16V5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 8C3.89543 8 3 8.89543 3 10C3 11.1046 3.89543 12 5 12C6.10457 12 7 11.1046 7 10V8H5ZM6 9H5C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11C5.55228 11 6 10.5523 6 10V9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 10C8 8.89543 8.89543 8 10 8H12V10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10ZM10 9H11V10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8C13.8954 8 13 8.89543 13 10C13 11.1046 13.8954 12 15 12C16.1046 12 17 11.1046 17 10V8H15ZM16 9H15C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10V9Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 15C3 13.8954 3.89543 13 5 13H7V15C7 16.1046 6.10457 17 5 17C3.89543 17 3 16.1046 3 15ZM5 14H6V15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 13C8.89543 13 8 13.8954 8 15C8 16.1046 8.89543 17 10 17C11.1046 17 12 16.1046 12 15V13H10ZM11 14H10C9.44772 14 9 14.4477 9 15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15V14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 15C13 13.8954 13.8954 13 15 13H17V15C17 16.1046 16.1046 17 15 17C13.8954 17 13 16.1046 13 15ZM15 14H16V15C16 15.5523 15.5523 16 15 16C14.4477 16 14 15.5523 14 15C14 14.4477 14.4477 14 15 14Z"
        fill="currentColor"
      />
    </svg>
  );
}
